
    import '/home/ec2-user/Youlify-Design/components/skeleton/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["skeleton-demo-basic","skeleton-demo-complex","skeleton-demo-active","skeleton-demo-element","skeleton-demo-children","skeleton-demo-list","skeleton-demo-componenttoken"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/skeleton/index.en-US.md?type=demo')
};